import type { App } from 'vue'
import pinia from '@/store'
import { useLogin } from '@/store/login'

/**
 * 用户权限指令
 * @directive 单个权限验证（v-auth="xxx"）
 * @directive 多个权限验证，满足一个则显示（v-auths="[xxx,xxx]"）
 * @directive 多个权限验证，全部满足则显示（v-auth-all="[xxx,xxx]"）
 */
export function authDirective(app: App) {
  // 单个权限验证（v-auth="xxx"）
  app.directive('auth', {
    mounted(el, binding) {
      const stores = useLogin() as any
      const roleType = stores.userInfos?.roleType
      const authBtnList = stores.getAuthBtnList()
      if (!authBtnList.includes(binding.value) && roleType !== 'admin') el.parentNode.removeChild(el)
    }
  })
}
